const API = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "clymaco_client_token";
const REFRESH_KEY = "clymaco_client_refresh";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setSession(token, refreshToken) {
  localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

export function formatDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg ? e.msg : String(e))).join(" ");
  return String(detail);
}

async function tryRefresh() {
  const rt = localStorage.getItem(REFRESH_KEY);
  if (!rt) return false;
  try {
    const resp = await fetch(`${API}/api/client/auth/refresh`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: rt }),
    });
    if (!resp.ok) return false;
    const data = await resp.json();
    setSession(data.token, data.refresh_token);
    return true;
  } catch {
    return false;
  }
}

export async function portalApi(path, options = {}, allowRetry = true) {
  const resp = await fetch(`${API}/api${path}`, {
    ...options,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}`, ...(options.headers || {}) },
  });
  if (resp.status === 401 && allowRetry) {
    if (await tryRefresh()) return portalApi(path, options, false);
    clearSession();
    window.location.href = "/portal/login";
    throw new Error("Session expired. Please log in again.");
  }
  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    const err = new Error(formatDetail(data.detail));
    err.status = resp.status;
    throw err;
  }
  return resp.json();
}
